import * as React from "react";

export const IconLogin = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_1313_3225)">
      <path
        d="M9.16797 5.83333L8.0013 7L10.168 9.16667L1.66797 9.16667L1.66797 10.8333L10.168 10.8333L8.0013 13L9.16797 14.1667L13.3346 10L9.16797 5.83333ZM16.668 15.8333H10.0013V17.5H16.668C17.5846 17.5 18.3346 16.75 18.3346 15.8333L18.3346 4.16667C18.3346 3.25 17.5846 2.5 16.668 2.5L10.0013 2.5V4.16667L16.668 4.16667V15.8333Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_1313_3225">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
